module.exports = __webpack_public_path__ + "static/media/lg_color.2ac8e1dc.jpg";